export const REPORT_TYPE = {
  INVENTORY_DETAIL: "InventoryDetail", //chi tiết tồn kho
  INVENTORY_WARNING: "InventoryWarning", //tồn kho dưới định mức
  ORDER_EXPORT: "OrderExport", //xuất thông tin hóa đơn
  DEBT_OUTBOUND: "DebtOutbound", //nợ phải thu
  INVENTORY: "Inventory", //xuất nhập tồn sp
  INCOME: "Income", //doanh thu
};

export const HISTORY_TYPE = {
  SALES: "Sales",
  WAREHOUSE: "Warehouse",
};

export const CONTEXT_TYPE = {
  TRANSFER: "Transfer",
  REMOVE: "Remove",
  RETURN: "Return",
  ORDER: "Order",
};

export const TYPE = {
  INBOUND: "Inbound",
  OUTBOUND: "Outbound",
};

export const STATUS = {
  PAID: "Paid",
  UNPAID: "Unpaid",
  DRAFT: "Draft",
};
